import React from 'react';
import {
  Await,
  Link,
  useLoaderData,
} from '@tanstack/react-router';

import EmailConfirmationForm from '../components/EmailConfirmationForm';
import Loading from '../components/Loading';

const EmailConfirmation: React.FC = () => {
  const { confirmationResult } = useLoaderData({ strict: false });

  return (
    <div className="container email-confirmation-container">
      <Await promise={confirmationResult} fallback={<Loading />}>
        {(confirmationResult: { status: number }) => {
          return (
            <div className="wa-stack wa-gap-md">
              {confirmationResult.status === 200 ? (
                <>
                  <h3 className="page-title center">
                    Email confirmed!
                  </h3>
                  <p className="center">
                    You can now <Link to="/login">log in</Link>.
                  </p>
                </>
              ) : (
                <>
                  <h3 className="page-title center">
                    Email confirmation failed!
                  </h3>
                  <p className="center">
                    If you are sure it was a mistake, you can try again.
                  </p>
                  <EmailConfirmationForm />
                  <p className="center">
                    If the problem persists, please contact support at <a href="mailto:Grace@lgcystory.com">Grace@lgcystory.com</a>
                  </p>
                </>
              )}
            </div>
          );
        }}
      </Await>
    </div>
  );
}

export default EmailConfirmation;
